module.exports = __webpack_public_path__ + "img/amazon-kindlefire-white_badge.2512db0a.png";